import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  constructor() {}

  public myData={};

  public getData(dataName:string):any | undefined {
    return this.myData[dataName];
  }

  public setData(data: any, dataName: string) {
    this.myData[dataName] = data;
  }
}
